import React from "react";

const PartyPopper = () => (
  <span role="img" aria-label="tada">
    🎉
  </span>
);

export default PartyPopper;
